module.exports = require("admin/components/highlighted-code");